<app-dashboard-container
	class="dashboard-aanwezigheid-datavolledigheid"
	[factTable]="factTable"
	[attOverrides]="attOverrides"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions(), $event)"
>
	<app-filter-panel
		[defaultFilters]="defaultFilters"
		[overrideDefault]="overrideDefault"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/aanwezigheid"
		[permanentFilterExpressions]="permanentFilterExpressions()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-legenda class="cl-header-utility" [attribute]="['aw_is_presentieregistratie_verwerkt']"></app-legenda>
		</app-dashboard-header>
		<app-barchart-table
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilterExpressions()"
			[groups]="groeperingService.huidigeGroeperingen()"
			[config]="this"
		></app-barchart-table>
	</section>
</app-dashboard-container>
